import axios from 'axios';
import {  DHB_API_CHAT, omitEmptyValue } from './utils';

const instance = axios.create({
  baseURL: DHB_API_CHAT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

instance.interceptors.request.use(
  async (config) => {
    config.data = config.data || {};
    config.baseURL = DHB_API_CHAT;
    if(config.params){
      config.params = omitEmptyValue(config.params)  
    }
    return config;
  }
);
export const httpChat = instance

export async function postEventStream(
  path: string,
  payload: any,
  options?: { signal?: AbortSignal; headers?: Record<string, string> }
) {
  const url = `${DHB_API_CHAT}${path.startsWith('/') ? path : `/${path}`}`;
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
      ...(options?.headers || {}),
    },
    body: JSON.stringify(payload),
    signal: options?.signal,
    credentials: 'include',
  });
}
